import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateTicketFormValues, EditTicketFormValues } from '../../../types/form';
import { FORM_FIELD_KEY } from '../../containers/Pages/TicketPages/TicketPagesContentLayout/AgentFormActiveFieldsContainer';
import GrispiInput from '../GrispiInput/index';

const FormSelectInput = () => {
    const { t } = useTranslation('forms');

    return (
        <Controller<CreateTicketFormValues | EditTicketFormValues, typeof FORM_FIELD_KEY>
            name={FORM_FIELD_KEY}
            render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <GrispiInput
                    antdProps={{ allowClear: false }}
                    containerProps={{ label: 'Form', errorMessage: error?.message }}
                    type="FORM"
                    value={!+value ? null : +value}
                    onBlur={onBlur}
                    onChange={onChange}
                />
            )}
            rules={{ required: t('form.required') }}
        />
    );
};

export default FormSelectInput;
